export const CreditsPlusIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2413 3.94413e-07H5.7587C4.95375 -1.16214e-05 4.28936 -2.15359e-05 3.74818 0.0441952C3.18608 0.0901204 2.66938 0.188685 2.18404 0.435976C1.43139 0.819469 0.819469 1.43139 0.435975 2.18404C0.188685 2.66938 0.0901204 3.18608 0.0441952 3.74818C-2.15396e-05 4.28936 -1.16214e-05 4.95373 3.94414e-07 5.75869V12.2413C-1.16214e-05 13.0463 -2.15359e-05 13.7106 0.0441952 14.2518C0.0901204 14.8139 0.188685 15.3306 0.435976 15.816C0.819469 16.5686 1.43139 17.1805 2.18404 17.564C2.66938 17.8113 3.18608 17.9099 3.74818 17.9558C4.28937 18 4.95372 18 5.75868 18H12.2413C13.0463 18 13.7106 18 14.2518 17.9558C14.8139 17.9099 15.3306 17.8113 15.816 17.564C16.5686 17.1805 17.1805 16.5686 17.564 15.816C17.8113 15.3306 17.9099 14.8139 17.9558 14.2518C18 13.7106 18 13.0463 18 12.2413V5.75868C18 4.95372 18 4.28937 17.9558 3.74818C17.9099 3.18608 17.8113 2.66938 17.564 2.18404C17.1805 1.43139 16.5686 0.819469 15.816 0.435976C15.3306 0.188685 14.8139 0.0901204 14.2518 0.0441952C13.7106 -2.15396e-05 13.0463 -1.16214e-05 12.2413 3.94413e-07ZM8.52569 3.84186L7.35475 7.35469L3.84192 8.52563V9.47431L7.35475 10.6453L8.52569 14.1581H9.47437L10.6453 10.6453L14.1581 9.47431V8.52563L10.6453 7.35469L9.47437 3.84186H8.52569Z"
        fill="url(#paint0_linear_3612_12958)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3612_12958"
          x1="9.00106"
          y1="18.8194"
          x2="0.424654"
          y2="6.75033"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EED8FF" />
          <stop offset="0.926577" stopColor="#9D4EDD" />
        </linearGradient>
      </defs>
    </svg>
  );
};
